import { createPinia, Pinia, StateTree } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';

/*
 * Pinia store factory function for Vite
 */

// Derived from tiny obfuscator in localstorage-slim
const key: number = 74;

function encrypt(str: StateTree): string {
  return [...JSON.stringify(str)].map((x) => String.fromCharCode(x.charCodeAt(0) + key)).join('');
}

function decrypt(str: string): StateTree {
  return JSON.parse([...str].map((x) => String.fromCharCode(x.charCodeAt(0) - key)).join(''));
}

/**
 * Reads a store's saved state straight from storage, before Pinia restores
 * it. Null when nothing is saved or it cannot be read.
 */
export function readSavedState(key: string): StateTree | null {
  const saved = localStorage.getItem(key);
  if (saved === null) return null;
  try {
    return decrypt(saved);
  } catch {
    return null;
  }
}

export default function (): Pinia {
  const pinia = createPinia();

  const state = createPersistedState({
    storage: localStorage,
    beforeRestore: () => {},
    afterRestore: () => {},
    serializer: {
      serialize: encrypt,
      deserialize: decrypt,
    },
  });

  pinia.use(state);

  return pinia;
}
